"use client";

import { useRouter } from "next/navigation";
import { use, useEffect } from "react";

import { Button } from "@/components/ui/button";
import { UserContext } from "@/contexts/user-context";

import { useToast } from "../ui/use-toast";

type BountyErrorLayoutProps = {
  error: Record<string, string>;
  reset: () => void;
};

export const BountyErrorLayout = ({ error, reset }: BountyErrorLayoutProps) => {
  const router = useRouter();
  const { toast } = useToast();
  const { loggedIn } = use(UserContext);

  useEffect(() => {
    // Note: set timeout to avoid SSR error - on first render, the toast is not yet available
    setTimeout(() => {
      toast({
        variant: "destructive",
        title: "Error",
        description: `An error happened  - ${error?.message}`,
      });
    }, 0);
  }, [error, router, toast]);

  return (
    <div className="mt-20 flex flex-col items-center justify-center gap-2">
      <h2 className="text-2xl">
        {!loggedIn ? "Unauthorized" : "Something went wrong!"}
      </h2>

      <Button
        variant="default"
        onClick={() => reset()}
        className="flex justify-end gap-1"
      >
        Try again
      </Button>
    </div>
  );
};
